import { connect } from 'react-redux'
import { getNodesByIds } from '../../core/selectors'
import { getNodeSelectionById } from '../../selection/selectors'
import { getHouseTypeRoot } from '../selectors'
import HouseTypeRoot from '../components/houseTypeRoot'

const mapStateToProps = (state, ownProps) => ({
  handleClick: id => ownProps.history.push(`/haustyp/${id}`),
  houseTypes: getNodesByIds({
    state,
    ids: getHouseTypeRoot(state).children,
  }),
  parentSelection: getNodeSelectionById({
    state,
    id: getHouseTypeRoot(state).id,
  }),
})

export default connect(
  mapStateToProps,
  null,
)(HouseTypeRoot)



// WEBPACK FOOTER //
// ./src/modules/houseType/containers/houseTypeRoot.js